const params = new URLSearchParams(window.location.search);

export function getLocaleFromUrl() {
  const locale = params.get('locale');
  if (locale) {
    deleteLocaleFromUrl();
  }
  return locale;
}

function deleteLocaleFromUrl() {
  params.delete('locale');
  window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
}
